interface JdidProps {
  jdid: string;
}

export const Jdid = ({ jdid }: JdidProps) => (
  <div id="jane-jdid" data-jdid={jdid} />
);
